module.exports = __webpack_public_path__ + "assets/72a225e4546e5abaab034bb6b010d5a4.png";